/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { InvitationsControllerGetPermissionsQueryResponse, InvitationsControllerGetPermissionsPathParams, InvitationsControllerGetPermissions401, InvitationsControllerGetPermissions403 } from "../../models/invitationsController/InvitationsControllerGetPermissions";

function getInvitationsControllerGetPermissionsUrl(id: InvitationsControllerGetPermissionsPathParams["id"]) {
  const res = { method: 'GET', url: `/api/v1/invitations/${id}/permissions` as const }  
  return res
}

/**
 * @description The invitation's targets expanded to every scope they reach, limited to the caller's reach.
 * @summary Get invitation scope permissions
 * {@link /api/v1/invitations/:id/permissions}
 */
export async function invitationsControllerGetPermissions(id: InvitationsControllerGetPermissionsPathParams["id"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<InvitationsControllerGetPermissionsQueryResponse, ResponseErrorConfig<InvitationsControllerGetPermissions401 | InvitationsControllerGetPermissions403>, unknown>({ method : "GET", url : getInvitationsControllerGetPermissionsUrl(id).url.toString(), ... requestConfig })  
  return res.data
}